var map = {
	"./Green-VeryLow.png": 818,
	"./Green-VeryLow.svg": 1729,
	"./Red-Excessive.png": 814,
	"./Red-Excessive.svg": 1730,
	"./RedYellow-Significant.png": 815,
	"./RedYellow-Significant.svg": 1731,
	"./White-Unknown.png": 587,
	"./White-Unknown.svg": 1732,
	"./Yellow-Moderate.png": 816,
	"./Yellow-Moderate.svg": 1733,
	"./YellowGreen-Low.png": 817,
	"./YellowGreen-Low.svg": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1728;